import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { dashboardPath } from "./routePaths";

const NotFoundComp = () => {

    const navigate = useNavigate()

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
        >
            <Typography>
                The path you are trying to access does not exist.
            </Typography>
            <Button
                variant="contained"
                onClick={() => navigate(dashboardPath)}
            >
                Go to dashboard
            </Button>
        </Stack>
    )

}

export default NotFoundComp;